export class TransportTypeEnum {
    static LINE = "LINE";
    static MAINTENANCE = "MAINTENANCE";
}
